<template>
  <div class="change-email">
    <el-tabs v-show="!showNewInputPassword" v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane :label="$t("setting.changePasswordMt5.messageVerify")" name="phone">
        <h4 v-show="h4Show">{{$t("setting.changePhone.phoneTitle")}} {{params.changePhoneNumShow}}</h4>
        <el-form :model="phoneForm"
                :rules="rules"
                ref="phoneForm"
                class="form-change-phone"
                :label-position="labelPosition">
          <el-form-item prop="verCode"  :label-width="formLabelWidth">
            <el-input v-model="phoneForm.verCode"
                      :placeholder="$t('setting.changePhone.verCodePlaceholder')"
                      autocomplete="off">
            <span :style="countStyle" @click="getVerificationCode" class="append-text btn-code" slot="suffix">
              <span>{{ToolTip}}</span>
            </span>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="footer-wrap">
          <div class="el-button--sub">
            <el-button type="primary"
                    class="submit-button"
                    @click="submitForm('phoneForm')">{{$t('setting.setPassword.submit')}}</el-button>
          </div>
          <div class="el-button--cencel">
            <el-button type="primary"
                    class="cancel-button"
                    @click="resetForm('phoneForm')">{{$t('setting.setPassword.cancel')}}</el-button>
          </div>
      </div>
      </el-tab-pane> -->
      <el-tab-pane :label="$t('setting.changePasswordMt5.emailVerify')" name="email">
        <div class="tip">
          <span v-html="oldTip"></span>
        </div>
        <el-form :model="emailForm" ref="emailForm" :rules="rules" label-width="0" class="demo-ruleForm">
          <el-form-item label="" prop="code">
            <el-input v-model="emailForm.code" :placeholder="$t('setting.changePhone.verCodePlaceholder')" :maxlength="6">
              <span class="btn-code" slot="suffix" @click="getCode" :style="countStyle">{{ToolTip}}
              </span>
            </el-input>
          </el-form-item>
        </el-form>

        <div class="el-button--sub">
          <el-button type="primary" @click="submitForm('emailForm')">{{$t('changeEmail.submit')}}</el-button>
        </div>
        <div class="el-button--cencel">
          <el-button type="primary" @click="resetForm('emailForm')">{{$t('changeEmail.cencel')}}</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-form v-show="showNewInputPassword" ref="newPasswordForm" :rules="rules" :model="newPasswordForm" label-width="0">
      <h3>{{$t('setting.changePasswordMt5.title')}}</h3>
      <el-form-item prop="newPassword" label="">
        <el-input type="password" :placeholder="$t('setting.changePasswordMt5.inputNewPassword')" v-model="newPasswordForm.newPassword"></el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword" label="">
        <el-input type="password" :placeholder="$t('setting.changePasswordMt5.inputNewPasswordAgain')" v-model="newPasswordForm.confirmPassword"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="el-button--sub">
          <el-button :loading="loading" @click="changePasswordHandle('newPasswordForm')" type="primary">确定</el-button>
        </div>
        <div class="el-button--cencel">
          <el-button :disabled="cancel" @click="resetForm('newPasswordForm')" type="primary">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { Base64 } from 'js-base64'
export default {
  props: ['params'],
  data () {
    // var checkVerCode = (rule, value, callback) => {
    //   let verCode = Cookies.get('phone_number' + this.params.changePhoneNum)
    //   console.log(value)
    //   if (!value) {
    //     return callback(new Error(this.$t('setting.changePhone.codeInput')))
    //   } else if (value !== verCode) {
    //     return callback(new Error(this.$t('common.codeFail')))
    //   } else {
    //     callback()
    //   }
    // }
    const checkEmailCode = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('changeEmail.code')))
      }
      // this.$api.verifyEmailCode({
      //   data: data,
      //   type: 'old'
      // }).then(result => {
      //   if (result.data.status == 1) {
      //     return callback(new Error(this.$t('changeEmail.error.1')))
      //   } else if (result.data.status == 0) {
      //     return callback(new Error(this.$t('changeEmail.error.0')))
      //   } else if (result.data.status == 3) {
      //     return console.log(result.data.msg)
      //   } else {
      //     callback()
      //   }
      // })
    }
    const checkNewPassword = (rule, value, callback) => {
      // 6-16位数字字母组合
      let patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      if (!value) {
        return callback(new Error(this.$t('common.inputNewPassword')))
      } else if (!patrn.exec(value)) {
        return callback(
          new Error(this.$t('setting.changePasswordMt5.checkPassword'))
        )
      } else {
        callback()
      }
    }
    const checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('common.inputNewPasswordAgain')))
      } else if (value !== this.newPasswordForm.newPassword) {
        return callback(new Error(this.$t('common.notIdentical')))
      } else {
        callback()
      }
    }
    return {
      disabledSubmit: false,
      emailForm: {
        email: '',
        code: ''
      },
      // phoneForm: {
      //   newPhone: '',
      //   verCode: '',
      //   area: '+86'
      // },
      newPasswordForm: {
        newPassword: '',
        confirmPassword: ''
      },
      newTip: this.$t('changeEmail.newTip'),
      oldTip: this.$t('changeEmail.oldTip', [this.params.email]),
      rules: {
        code: [
          {
            trigger: 'blur',
            validator: checkEmailCode
          }
        ],
        // verCode: [
        //   { validator: checkVerCode, trigger: 'change' }
        // ],
        newPassword: [{ validator: checkNewPassword, trigger: 'change' }],
        confirmPassword: [
          { validator: checkConfirmPassword, trigger: 'change' }
        ]
      },
      activeName: 'email',
      h4Show: true,
      subWrapShow: false,
      labelPosition: 'top',
      newPhoneShow: false,
      formLabelWidth: '0',
      isEnter: false,
      countStyle: '',
      ToolTip: this.$t('setting.changePhone.sendVerTip'),
      cancel: false,
      loading: false,
      countdown: 60,
      showNewInputPassword: false,
      language: sessionStorage.getItem('language')
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  methods: {
    getEmailLanguage () {
      let language = sessionStorage.getItem('language')
      switch (language) {
        case 'hk':
          return 'CHT'
        case 'cn':
          return 'CHS'
        default:
          return 'CHS'
      }
    },
    getEmailService (email) {
      let hash = {
        'qq.com': 'http://mail.qq.com',
        'gmail.com': 'http://mail.google.com',
        'sina.com': 'http://mail.sina.com.cn',
        '163.com': 'http://mail.163.com',
        '126.com': 'http://mail.126.com',
        'yeah.net': 'http://www.yeah.net/',
        'sohu.com': 'http://mail.sohu.com/',
        'tom.com': 'http://mail.tom.com/',
        'sogou.com': 'http://mail.sogou.com/',
        '139.com': 'http://mail.10086.cn/',
        'hotmail.com': 'http://www.hotmail.com',
        'live.com': 'http://login.live.com/',
        'live.cn': 'http://login.live.cn/',
        'live.com.cn': 'http://login.live.com.cn',
        '189.com': 'http://webmail16.189.cn/webmail/',
        'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
        'yahoo.cn': 'http://mail.cn.yahoo.com/',
        'eyou.com': 'http://www.eyou.com/',
        '21cn.com': 'http://mail.21cn.com/',
        '188.com': 'http://www.188.com/',
        'foxmail.coom': 'http://www.foxmail.com'
      }
      let add = email.slice(email.indexOf('@') + 1)
      for (let key in hash) {
        if (key === add) {
          return hash[key]
        }
      }
      return false
    },
    async sendCode () {
      let data = {
        email: this.params.email,
        lang: this.getEmailLanguage() // CHS 简体　CHT 繁体
      }
      console.log(data)
      // 发送邮件验证码
      await this.$store
        .dispatch('getPMCode', data)
        .then(result => {
          let tip = ``
          if (result.code === 200 && result.data === null) {
            this.$message({
              message: this.$t('changeEmail.sendSuccess'),
              type: 'success'
            })
            tip = result.msg
            let href = this.getEmailService(data.email)
            if (!href) {
              tip = this.$t('changeEmail.showTip1', [data.email])
            } else {
              tip = this.$t('changeEmail.showTip2', [data.email, href])
            }
          }
          this.oldTip = tip
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCode () {
      this.countdown = 60
      this.countStyle = { 'pointer-events': 'none' }
      this.countDown()
      this.sendCode()
    },
    handleClick (tab, event) {
      // console.log(tab, event)
      this.countdown = 0
      this.$refs['emailForm'].resetFields()
      this.$refs['phoneForm'].resetFields()
    },
    // 验证码倒计时
    countDown () {
      var vm = this
      if (vm.countdown == 0) {
        vm.countStyle = ''
        vm.ToolTip = this.$t('setting.changePhone.sendVerTip')
        vm.countdown = 60
        return
      } else {
        vm.ToolTip = vm.countdown + 's'
        vm.countdown--
      }
      setTimeout(function () {
        vm.countDown()
      }, 1000)
    },
    // verificationCode () {
    //   let phoneKey = this.params.changePhoneNum

    //   let param = {
    //     phoneNumber: this.params.changePhoneNum
    //   }
    //   this.$exodusApi.getExodusVerCode(param).then(result => {
    //     if (result.code == 200) {
    //       Cookies.set('phone_number' + phoneKey, result.data.verifyCode, { expires: 0.05 })
    //     }
    //   })
    // },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            email: this.params.email,
            code: this.emailForm.code
          }
          // this.$store
          //   .dispatch('verifyCode', data)
          //   .then(result => {
          //     console.log(result)
          //     if (result.code === 203) {
          //       return callback(new Error(this.$t('changeEmail.error.1')))
          //     } else if (result.code === 204) {
          //       return callback(new Error(this.$t('changeEmail.error.0')))
          //     } else {
          //       this.showNewInputPassword = true
          //     }
          //   })
          //   .catch(err => {
          //     // let errMsg = JSON.parse(err.msg)
          //     console.log(err)
          //     callback(new Error(errMsg.message))
          //   })
          let result = this.$store.dispatch('verifyCode', data)
          result.then(
            result => {
              console.log(result)
              if (result.data === null) {
                this.showNewInputPassword = true
              } else if (result.data.code == 203) {
                return this.$message.error(this.$t('changeEmail.error.1'))
              } else if (result.data.code == 204) {
                return this.$message.error(this.$t('changeEmail.error.0'))
              }
            }
          ).catch(err => {
            console.log(err)
          })
        } else {
          this.$message.error(this.$t('common.changeFail'))
          return false
        }
      })
    },
    resetForm (formName) {
      this.countdown = 0
      this.showNewInputPassword = false
      // this.$refs['phoneForm'].resetFields()
      this.$refs['emailForm'].resetFields()
      this.$refs['newPasswordForm'].resetFields()
      this.$emit('closeFun', false)
    },
    NotClickable () {
      this.loading = true
      this.cancel = true
    },
    clickable () {
      this.loading = false
      this.cancel = false
    },
    async changePassword () {
      this.NotClickable()
      let options = {
        login: this.params.tradeAccount,
        password: Base64.encode(this.newPasswordForm.newPassword)
      }
      await this.$store
        .dispatch('resetPwd', options)
        .then(result => {
          if (result.data.status === 0) {
            this.$message({
              message: this.$t('common.changeSuccess'),
              type: 'success'
            })
            this.resetForm()
            let options = {
              account: this.params.tradeAccount,
              email: this.params.email,
              name: this.getUser.profile.family_name,
              lang: this.getEmailLanguage()
            }
            this.$store.dispatch('resetSuccess', options)
          } else if (result.data.status === -1) {
            this.clickable()
            this.$message.error(this.$t('common.changeFail'))
          }
        })
        .catch(error => {
          this.clickable()
          this.$message.error(this.$t('common.changeFail'))
        })
      // return this.$api.changePasswordPM({
      //   login: '81098005',
      //   login: this.params.tradeAccount,
      //   password: Base64.encode(this.newPasswordForm.newPassword)
      // }).then(result => {
      //   console.log(result)
      //   this.clickable()
      //   if (result.data.status === 0) {
      //     this.$message({
      //       message: this.$t('common.changeSuccess'),
      //       type: 'success'
      //     })
      //     this.resetForm()
      //   } else {
      //     this.$message.error(this.$t('common.changeFail'))
      //   }
      // }).catch(error => {
      //   this.clickable()
      //   this.$message.error(this.$t('common.changeFail'))
      //   console.log(error.msg)
      // })
    },
    changePasswordHandle (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.changePassword()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.change-email {
  padding: 20px;
  height: auto;

  .title {
    text-align: center;
    font-size: 22px;
    color: #24282d;
  }

  .el-form {
    margin-bottom: 20px;
  }

  .el-input {
    height: 43px;
  }

  .el-button--sub {
    width: 100%;

    .el-button {
      width: 100%;
      color: #192b57;
      font-weight: bold;
      height: 58px;
      border-color: #ffe080;
      background-color: #fecd33;
    }
  }

  .el-button--cencel {
    width: 100%;

    .el-button {
      margin-top: 20px;
      width: 100%;
      color: #192b57;
      font-weight: bold;
      height: 58px;
      border-color: #192b57;
      background-color: #fff;
    }
  }

  .btn-auth-code {
    cursor: no-drop;
    height: 100%;
    line-height: 43px;
    color: #ccc;
    margin-right: 10px;
    font-size: 14px;
  }

  .btn-code {
    cursor: pointer;
    height: 100%;
    line-height: 43px;
    color: #fec000;
    margin-right: 10px;
    font-size: 14px;
  }

  .tip {
    text-align: center;
    font-size: 14px;
    color: #24282d;
    word-break: break-all;
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
</style>
